import { useState } from "react";
import { useLocations } from "../../hooks/useLocations";
import {
  DataTable,
  Input,
  Button
} from '@tonic/shared/components/ui';
import { Plus, Search } from "lucide-react";
import { columns } from "./columns";
import { CreateLocationDialog } from "./CreateLocationDialog";

export function LocationList() {
  const [searchQuery, setSearchQuery] = useState("");
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const { data: locations, isLoading, error } = useLocations();
  
  console.log("Locations data:", locations);
  console.log("Loading state:", isLoading);
  console.log("Error:", error);

  const filteredLocations = locations?.filter((location) =>
    location.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    location.code.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <div className="flex justify-between">
        <div>
          <h1 className="text-3xl font-bold">Locations</h1>
          <p className="text-muted-foreground">
            Manage warehouse locations and storage areas
          </p>
        </div>
        <Button onClick={() => setIsCreateDialogOpen(true)}>
          <Plus className="mr-2 h-4 w-4" />
          Add Location
        </Button>
      </div>

      <div className="flex items-center space-x-2">
        <div className="relative flex-1 max-w-sm">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search locations..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-8"
          />
        </div>
      </div>

      <DataTable
        columns={columns}
        data={filteredLocations || []}
        isLoading={isLoading}
      />

      <CreateLocationDialog
        open={isCreateDialogOpen}
        onOpenChange={setIsCreateDialogOpen}
      />
    </div>
  );
} 
